module.exports = __webpack_public_path__ + "media/images/mail/more-item-btn-3c441fded4d665b0d5ae15f51c072c26.png";